import { Box, Text, Checkbox } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { FC } from 'react';
import { StatusAlertFilledSmall } from '@wix/wix-ui-icons-common';
import s from './CustomCodeConsentContent.module.scss';

interface ConsentModalContentProps {
  onClick: () => void;
  isChecked: boolean;
  hasError?: boolean;
  isMobile?: boolean;
}

const CustomCodeConsentContent: FC<ConsentModalContentProps> = ({
  onClick,
  isChecked,
  hasError,
  isMobile,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      direction="vertical"
      marginBottom="12px"
      className={isMobile ? s.mobileLayout : s.layout}
    >
      <Text size="small" weight="thin">
        {t('marketplace.template-page.custom-code-consent-modal.subtitle')}
      </Text>
      <Text size="small" weight="thin" listStyle="circle">
        <ul className={s.listSpacing}>
          <li>
            {t('marketplace.template-page.custom-code-consent-modal.bullet-1')}
          </li>
          <li>
            {t('marketplace.template-page.custom-code-consent-modal.bullet-2')}
          </li>
          <li>
            {t('marketplace.template-page.custom-code-consent-modal.bullet-3')}
          </li>
        </ul>
      </Text>
      <Box display="inline-block">
        <Checkbox
          size="small"
          checked={isChecked}
          onChange={onClick}
          hasError={hasError}
        >
          {t(
            'marketplace.template-page.custom-code-consent-modal.toggle-label',
          )}
          <Box display="inline-block" className={s.asterisk}>
            *
          </Box>
        </Checkbox>
        {hasError && <ErrorMessage />}
      </Box>
    </Box>
  );
};

export default CustomCodeConsentContent;

const ErrorMessage = () => {
  const { t } = useTranslation();
  return (
    <Box align="left" paddingTop="6px" dataHook="consent-terms-error">
      <StatusAlertFilledSmall color="red" />
      <Text skin="error" size="small" weight="thin">
        &nbsp;
        {t(
          'marketplace.template-page.custom-code-consent-modal.acceptance-error',
        )}
      </Text>
    </Box>
  );
};
